import {Component} from 'react'
import { buscarEnderecoPorCEP } from '../service/Service'
import { TAMANHO_CEP } from '../constants'
import PropTypes from 'prop-types'

class BuscaEnderecoPorCEP extends Component{
    state = {
        erroBuscaEndereco: null,
        buscandoEndereco: false
    }

    static propTypes = {
        quandoCarregarEndereco: PropTypes.func.isRequired,
        onChangeCEP: PropTypes.func.isRequired
    }

    handleChange = (event) => {
        if (this.state.erroBuscaEndereco){
            this.setState({
                erroBuscaEndereco: null
            })
        }
        let CEP = event.target.value.replace(/\D/g, '')

        if (CEP.length === TAMANHO_CEP){
            this.setState({
                buscandoEndereco: true,
                erroBuscaEndereco: null
            })
            buscarEnderecoPorCEP(CEP)
                .then(response => {
                    this.props.quandoCarregarEndereco(response)
                    this.setState({
                        buscandoEndereco: false
                    })
                })
                .catch(() => {
                    this.setState({
                        buscandoEndereco: false,
                        erroBuscaEndereco: 'O CEP não foi encontrado'
                    })
                })
        }

        this.props.onChangeCEP(event)
    }

    render(){
        const { buscandoEndereco, erroBuscaEndereco } = this.state

        return this.props.children({
            buscandoEndereco,
            erroBuscaEndereco,
            onChangeCEP: this.handleChange
        })
    }
}

export default BuscaEnderecoPorCEP